<div class="logobox">
    <small>{{ 'Portal.Hint.Logo' | translate | persianNumber}}</small>
    <img width="200px" src="../../../assets/imgs/logo.png{{DateNow}}" alt="" srcset="">
    <ng-container *ngIf="uploadService.fileName">
        <small style="color: greenyellow;">{{uploadService.typeErr}}</small>
    </ng-container>
    <ng-container *ngIf="uploadService.sizeErr && uploadService.fileName">
        <small style="color: red;">{{ 'Portal.Hint.Logo' | translate }}</small>
    </ng-container>
    <app-filemanager (change)="share.reloadCurrentRoute()"></app-filemanager>
</div>
